var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrfRequestIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 1.6665H7.49935C7.03911 1.6665 6.66602 2.0396 6.66602 2.49984V4.1665C6.66602 4.62674 7.03911 4.99984 7.49935 4.99984H12.4993C12.9596 4.99984 13.3327 4.62674 13.3327 4.1665V2.49984C13.3327 2.0396 12.9596 1.6665 12.4993 1.6665Z",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.334 3.3335H15.0007C15.4427 3.3335 15.8666 3.50909 16.1792 3.82165C16.4917 4.13421 16.6673 4.55814 16.6673 5.00016V7.00012M6.66732 18.3335H5.00065C4.55862 18.3335 4.1347 18.1579 3.82214 17.8453C3.50958 17.5328 3.33398 17.1089 3.33398 16.6668V5.00016C3.33398 4.55814 3.50958 4.13421 3.82214 3.82165C4.1347 3.50909 4.55862 3.3335 5.00065 3.3335H6.66732",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 8H6",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 11H6",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.801 9V12C14.8009 12.1677 14.8431 12.3328 14.9235 12.48L17.6785 17.52C17.7618 17.6723 17.8041 17.8437 17.8011 18.0173C17.7981 18.1909 17.75 18.3607 17.6614 18.51C17.5729 18.6593 17.447 18.783 17.2961 18.869C17.1453 18.9549 16.9746 19 16.801 19H10.801C10.6274 19 10.4568 18.9549 10.3059 18.869C10.155 18.783 10.0291 18.6593 9.94061 18.51C9.85207 18.3607 9.80393 18.1909 9.80093 18.0173C9.79793 17.8437 9.84018 17.6723 9.92351 17.52L12.6785 12.48C12.759 12.3328 12.8011 12.1677 12.801 12V9",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0254 15.5H16.5724",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0488 9H15.5488",
    stroke: "white",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrfRequestIcon);
export default __webpack_public_path__ + "static/media/trfRequest-icon.1e6d82edf9353a46ac832cc7a20b823f.svg";
export { ForwardRef as ReactComponent };